import React, { useEffect, useRef, useState } from "react";
import { useCookies } from "react-cookie";
const TableData = ({ data, tableKeyName }) => {
  const [tableData, setTableData] = useState("");
  
  useEffect(() => {
    // fetchData();
    getData(data);
  }, []);

  function getData(data) {
    console.log('tableKeyName', tableKeyName);
    if (data.hasOwnProperty(tableKeyName)) {
      let tableDataArray = [];
      if (data[tableKeyName].hasOwnProperty("tables_data") &&  data[tableKeyName].tables_data != "") {
        data[tableKeyName].tables_data.forEach((table, index) => {
          tableDataArray.push(
            <div key={"index"+index}>
                <span className="tableTitle">{table.table_heading}</span>
                <div className={tableKeyName + "AstraDivTable"} key={index}>
                    <table className="table table-striped">
                        <thead>
                        <tr>
                            {table.table_th.map((th, thIndex) => (
                            <th key={thIndex}>{th}</th>
                            ))}
                        </tr>
                        </thead>
                        <tbody>
                        {table.table_tr.map((tr, trIndex) => (
                            <tr key={trIndex}>
                            {tr.map((td, tdIndex) => (
                                <td key={tdIndex}>{td}</td>
                            ))}
                            </tr>
                        ))}
                        </tbody>
                    </table>
                </div>
            </div>
          );
        });
        setTableData(tableDataArray);
      }
    }
  }

  return (
    <>{tableData}</>
  );
};

export default TableData;
